import { db } from "../firebaseConfig";
import { get, ref, set, update } from "firebase/database";

export interface UserSettings {
	themeMode?: "light" | "dark";
	maskProfit?: boolean;
}

export const getUserSettings = async (
	userId: string | null | undefined
): Promise<UserSettings> => {
	if (!userId) {
		return {};
	}

	try {
		const settingsRef = ref(db, `settings/${userId}`);
		const snapshot = await get(settingsRef);
		return snapshot.exists() ? (snapshot.val() as UserSettings) : {};
	} catch (error) {
		console.error("Failed to load user settings:", error);
		return {};
	}
};

export const updateUserSettings = async (
	userId: string | null | undefined,
	settings: UserSettings
): Promise<void> => {
	if (!userId) {
		return;
	}

	try {
		const settingsRef = ref(db, `settings/${userId}`);
		await update(settingsRef, settings);
	} catch (error) {
		console.error("Failed to update user settings:", error);
		throw error;
	}
};

export const setUserSettings = async (
	userId: string | null | undefined,
	settings: UserSettings
): Promise<void> => {
	if (!userId) {
		return;
	}

	try {
		const settingsRef = ref(db, `settings/${userId}`);
		await set(settingsRef, settings);
	} catch (error) {
		console.error("Failed to save user settings:", error);
		throw error;
	}
};
